import * as _4 from 'lodash4';

import { StudentMenuQuery } from '../../queries/student_menu_query';
import { ICommand } from 'core-ts-types';
import { INavItem } from '../../services/navigation_config_service';

/**
 *
 */
export class ResponsiveNavigationController {
  navList: INavItem[];

  constructor(
    private openOpenableElementCommand: ICommand,
    private loadStudentMenuCommand: ICommand,
    private getSTCConfigsCommand: ICommand,
    private ngStudentMenuQuery: StudentMenuQuery
  ) {}

  $onInit() {
    this.loadStudentMenuCommand();
    // we need to get the STC configs to determine the custom name for hand raise menu item
    this.getSTCConfigsCommand();
  }

  goTo(event: JQueryEventObject): void | boolean {
    const prop = (event as any).detail.value;

    if (prop.nk === 'HELP') {
      this.openOpenableElementCommand('appSupportDrawer');
      event.preventDefault();
      return false;
    } else {
      window['$ip'].require('@eab-pip/pi-dom').then((dom) => {
        setTimeout(() => dom.focusOnMain(), 700);
      });
    }
  }
}

export class ResponsiveNavigationComponent implements angular.IComponentOptions {
  public templateUrl = 'lib/responsive_navigation/views/responsive_navigation/responsive_navigation.html';
  public controller = ResponsiveNavigationController;
  public controllerAs: '$ctrl';
  public bindings = {};
}



// WEBPACK FOOTER //
// ./app/lib/responsive_navigation/views/responsive_navigation/responsive_navigation.ts